module.exports = __webpack_public_path__ + "6557442360b7a2e8f7e3f90cedddde57.png";